// extracted by mini-css-extract-plugin
module.exports = {"a6j6o3o":"a6j6o3o"};